import React, { FC } from 'react'
import CheckboxListFacet from '../components/CheckboxListFacet'
import { BaseFacetProps } from '../types'
import { OVERRIDE_STATUS_MAPPING_RULES } from '../helpers/constants'

const STATUS = ['avail', 'unavail', 'sold']

const StatusFacet: FC<BaseFacetProps> = ({ baseUrl, nextAppRoute }) => {
  return (
    <CheckboxListFacet
      facetName='original_status'
      attributesList={STATUS}
      overrideCheckboxTextRules={OVERRIDE_STATUS_MAPPING_RULES}
      baseUrl={baseUrl}
      nextAppRoute={nextAppRoute}
    />
  )
}

export default StatusFacet
